import React from "react";
import { divider } from "./Divider.module.scss";
const Divider = (props) => {
  return <hr className={`${divider} ${props.className}`} {...props} />;
};

export default Divider;
